import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  Stack,
  Tooltip,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import { Profile2User, Global, Message2 } from "iconsax-react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { fetchWorkspaces } from "../../../redux/Slice/Workspace/workspaceSlice";
import ConnectWhatsAppDialog from "./ConnectWhatsAppDialog";
import WhatsAppDetailsDialog from "./WhatsAppDetailsDialog";
import WhatsAppQrNumbersDialog from "./WhatsAppQrNumbersDialog";
import WhatsAppQrNumberSettingsDialog from "./WhatsAppQrNumberSettingsDialog";
import ConnectInstagramButton from "./ConnectInstagramButton";
import ConnectFacebookButton from "./ConnectFacebookButton";
import InstagramDetailsDialog from "./InstagramDetailsDialog";
import ConnectShopifyButton from "./ConnectShopifyButton";
import ShopifyDetailsDialog from "./ShopifyDetailsDialog";
import WhatsAppWebDialog from "./WhatsAppWebDialog";
import DisconnectShopifyButton from "./DisconnectShopifyButton";
import DisconnectSocialButton from "./DisconnectSocialButton";
import DisconnectChatbotButton from "./DisconnectChatbotButton";
import axios from "axios";
import { getAccessToken } from "../../../utils/tokenManager";
import { getAuthToken } from "../../../utils/getAuthToken";
import { fetchShopifyStatus } from "../../../services/shopifyApi";
import { fetchChatbotWidget } from "../../../services/chatbotApi";

const SERVER = process.env.REACT_APP_SERVER_DOMAIN || "http://localhost:8000";

const WhatsAppLogo = () => (
  <svg viewBox="0 0 24 24" width="100%" height="100%" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
  </svg>
);

// A browser window holding a chat: the contact continues the WhatsApp conversation in a browser.
const WhatsAppWebLogo = () => (
  <svg viewBox="0 0 24 24" width="100%" height="100%" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2.5" y="4" width="19" height="13" rx="2" />
    <path d="M8 20.5h8M12 17v3.5" />
    <path d="M7.5 8.5h9M7.5 11.5h5.5" />
  </svg>
);

const MessengerLogo = () => (
  <svg viewBox="0 0 24 24" width="100%" height="100%" fill="currentColor">
    <path d="M12 0C5.374 0 0 4.975 0 11.111c0 3.497 1.745 6.616 4.472 8.652V24l4.086-2.242c1.09.301 2.246.464 3.442.464 6.626 0 12-4.974 12-11.111S18.626 0 12 0zm1.218 14.963l-3.055-3.26-5.963 3.26L10.732 8l3.131 3.26L19.752 8l-6.534 6.963z" />
  </svg>
);

const InstagramLogo = () => (
  <svg viewBox="0 0 24 24" width="100%" height="100%" fill="url(#integrations-ig-gradient)">
    <defs>
      <linearGradient id="integrations-ig-gradient" x1="0" y1="1" x2="1" y2="0">
        <stop offset="0%" stopColor="#f09433" />
        <stop offset="40%" stopColor="#dc2743" />
        <stop offset="100%" stopColor="#bc1888" />
      </linearGradient>
    </defs>
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
  </svg>
);

const ShopifyLogo = () => (
  <svg viewBox="0 0 24 24" width="100%" height="100%" fill="currentColor">
    <path d="M15.337 23.979l7.216-1.561s-2.604-17.613-2.625-17.73c-.018-.116-.114-.192-.211-.192s-1.929-.136-1.929-.136-1.275-1.274-1.439-1.411c-.045-.037-.075-.057-.121-.074l-.914 21.104h.023zM11.71 11.305s-.81-.424-1.774-.424c-1.447 0-1.504.906-1.504 1.141 0 1.232 3.24 1.715 3.24 4.629 0 2.295-1.44 3.76-3.406 3.76-2.354 0-3.54-1.465-3.54-1.465l.646-2.086s1.245 1.066 2.28 1.066c.675 0 .975-.545.975-.932 0-1.619-2.654-1.694-2.654-4.359-.034-2.237 1.571-4.416 4.827-4.416 1.257 0 1.875.361 1.875.361l-.945 2.715-.02.01zM11.17.83c.136 0 .271.038.405.135-.984.465-2.064 1.639-2.508 3.992-.656.213-1.293.405-1.889.578C7.697 3.75 8.951.84 11.17.84V.83zm1.235 2.949v.135c-.754.232-1.583.484-2.394.736.466-1.777 1.333-2.645 2.085-2.971.193.501.309 1.176.309 2.1zm.539-2.234c.694.074 1.141.867 1.429 1.755-.349.114-.735.231-1.158.366v-.252c0-.752-.096-1.371-.271-1.871v.002zm2.992 1.289c-.02 0-.06.021-.078.021s-.289.075-.714.21c-.423-1.233-1.176-2.37-2.508-2.37h-.115C12.135.209 11.669 0 11.265 0 8.159 0 6.675 3.877 6.21 5.846c-1.194.365-2.063.636-2.16.674-.675.213-.694.232-.772.87-.075.462-1.83 14.063-1.83 14.063L15.009 24l.927-21.166z" />
  </svg>
);

// Website Chat isn't a third-party brand (unlike WhatsApp/Messenger/Instagram/
// Shopify above) — it's ClusterDen's own embeddable widget, so a plain message
// bubble read as generic and easy to confuse with the others. Globe (the
// website it's embedded on) + a small chat-bubble badge (Rahim, 2026-09-23:
// "use different icon... use different colour, i dont like blue").
const ChatLogo = () => (
  <Box sx={{ position: "relative", width: "100%", height: "100%" }}>
    <Box sx={{ width: "100%", height: "100%" }}>
      <Global size="100%" color="currentColor" variant="Linear" />
    </Box>
    <Box
      sx={{
        position: "absolute",
        bottom: -3,
        right: -3,
        width: 18,
        height: 18,
        borderRadius: "50%",
        bgcolor: "currentColor",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box sx={{ width: 11, height: 11, display: "flex", color: "background.paper" }}>
        <Message2 size="100%" color="currentColor" variant="Bold" />
      </Box>
    </Box>
  </Box>
);

// Footer status text (Connected / Reconnect needed / Paused) — plain bold colored
// text, no chip/border/box. An outlined pill in the same box as the neighbouring
// Details/Connect buttons read as a third clickable button, not a status (Rahim,
// 2026-09-23: "doesn't feel like its connected"). Matches TeamMembers.jsx's own
// "Active"/"Pending" status convention (bold, color-only, no container).
const CARD_STATUS_TEXT_SX = {
  fontSize: "0.8125rem",
  fontWeight: 700,
};

// "Popular" tab — straddles the card's top border (half above, half below), like a
// folder tab. Opaque base (background.default) + translucent brand-green wash on
// top: a purely translucent fill would let the border line show through it.
const POPULAR_PILL_SX = {
  position: "absolute",
  top: -10,
  left: 16,
  zIndex: 1,
  height: 20,
  display: "inline-flex",
  alignItems: "center",
  gap: "4px",
  px: "7px",
  borderRadius: "6px",
  fontSize: "0.75rem",
  fontWeight: 500,
  lineHeight: 1.4,
  color: (theme) => (theme.palette.mode === "dark" ? theme.palette.primary.light : theme.palette.primary.main),
  backgroundColor: "background.default",
  backgroundImage: (theme) => {
    const wash = alpha(theme.palette.primary.main, theme.palette.mode === "dark" ? 0.22 : 0.14);
    return `linear-gradient(${wash}, ${wash})`;
  },
};

// Neutral outlined footer button (grey border, primary text) — Inbox's ghost-button
// look instead of MUI's default green outline. Disabled state keeps MUI's own
// higher-specificity greying, so it isn't set here.
const CARD_BUTTON_SX = {
  width: "fit-content",
  textTransform: "none",
  borderRadius: "8px",
  color: "text.primary",
  borderColor: "divider",
  "&:hover": { borderColor: "text.secondary", backgroundColor: "action.hover" },
};

const CHANNELS = [
  {
    key: "whatsapp",
    name: "WhatsApp Business Platform (API)",
    description:
      "Connect WhatsApp Business App or WhatsApp Business API via Facebook to enable seamless customer engagement.",
    badge: "Popular",
    Logo: WhatsAppLogo,
    color: "#25D366",
    tint: "#25D366",
    real: true,
  },
  {
    key: "whatsapp-qr",
    name: "WhatsApp (Connect via QR)",
    description:
      "Link several existing WhatsApp numbers the same way WhatsApp Web does — no Meta Business setup required. Works alongside the official WhatsApp connection. An unofficial connection method; calling and message templates aren't available on it.",
    badge: "Beta",
    Logo: WhatsAppLogo,
    bg: "#128C7E",
    real: true,
  },
  {
    key: "whatsapp-web",
    name: "WhatsApp Webchat",
    description:
      "Send a contact a one-time link in WhatsApp so they can continue the same conversation in a browser chat. Needs the WhatsApp Business Platform (API) connected.",
    badge: null,
    Logo: WhatsAppWebLogo,
    color: "#00A884",
    tint: "#00A884",
    real: true,
  },
  {
    key: "messenger",
    name: "Facebook Messenger",
    description:
      "Connect Facebook Messenger to engage with your customers on the world's largest social media platform.",
    badge: "Popular",
    Logo: MessengerLogo,
    color: "#0084FF",
    tint: "#0084FF",
    real: true,
  },
  {
    key: "instagram",
    name: "Instagram",
    description:
      "Connect Instagram to reply to private messages and build strong brand connections.",
    badge: null,
    Logo: InstagramLogo,
    color: "#DC2743",
    tint: "#DC2743",
    real: true,
  },
  {
    key: "shopify",
    name: "Shopify",
    description:
      "Connect your Shopify store to automate order confirmations and shipping updates over WhatsApp.",
    badge: null,
    Logo: ShopifyLogo,
    color: "#95BF47",
    tint: "#95BF47",
    real: true,
  },
  {
    key: "chatbot",
    name: "Web Chat",
    description:
      "Add a live chat widget to your website so visitors can message your team directly from the same inbox.",
    badge: null,
    Logo: ChatLogo,
    color: "#7C5CFF",
    tint: "#7C5CFF",
    real: true,
  },
];

const Integrations = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { accountid } = useParams();
  const currentWorkspace = useSelector((s) => s.workspace?.currentWorkspace);
  // Who may use the card buttons: the Owner always, or a role given BOTH Integrations.View and Integrations.Manage
  // (Settings -> Roles & Permission). That covers the Meta, Instagram, Facebook, Shopify, WhatsApp QR and Web Chat cards (the server
  // accepts the same role for QR and the Web Chat widget). WhatsApp Web settings are the one exception: their server routes use
  // Workspace.View/Edit, so that card additionally needs Workspace.Edit -- otherwise its Save would only answer "permission denied".
  const roleName = useSelector((s) => s.userDetails.userDetails?.roleName);
  const rolePermissions = useSelector((s) => s.userDetails.userPermissions?.permissions) || {};
  const isAccountOwner = roleName === "Owner";
  const canManageIntegrations =
    isAccountOwner || (rolePermissions.Integrations?.View === true && rolePermissions.Integrations?.Manage === true);
  const canManageWhatsAppWeb = canManageIntegrations && (isAccountOwner || rolePermissions.Workspace?.Edit === true);
  // whatsappConnected stays Meta-only (set/unset exclusively by whatsappIntegrationRepository.js,
  // never written by QR code) -- the two cards read two independent signals, never one shared
  // flag, so a QR connection's own state changes (e.g. a later logout) can never leave the Meta
  // card showing "Details" for a connection that doesn't exist (the reverse of the "Incomplete
  // setup" bug this phase's plan originally flagged).
  const isWhatsAppConnected = Boolean(currentWorkspace?.whatsappConnected);
  // whatsappConnectionType resolves back to 'meta' once a QR connection goes LOGGED_OUT/STOPPED
  // (see whatsAppService.js's isActiveBaileysState) -- correct for send-routing, but wrong for
  // deciding which button this card shows: a logged-out QR connection still has a real
  // BaileysConnectionModel row and needs its own "Details" -> Reconnect UI, not a bare "Connect"
  // that loses the 14-day/manual-unlink explanation. whatsappQrState (the raw state string, or
  // null if no row exists at all) is the row-existence signal that survives that state change.
  const isQrConnected = currentWorkspace?.whatsappConnectionType === "baileys";
  const hasQrConnectionRecord = currentWorkspace?.whatsappQrState != null;
  // A workspace can hold Meta AND up to 5 QR numbers at once, so QR "connected" means any of its numbers is, not
  // whether the workspace as a whole resolves to QR (that is only true for a QR-only workspace).
  const qrConnections = Array.isArray(currentWorkspace?.whatsappQrConnections) ? currentWorkspace.whatsappQrConnections : [];
  const hasConnectedQrNumber = qrConnections.some((c) => c.state === "CONNECTED");
  // Pilot rollout & gating -- the QR card is shown ONLY while staff have QR enabled for the account (admin panel). When it is disabled the
  // worker logs the account's numbers out and the card disappears even if numbers/records exist: the data (numbers, chats, contacts) is
  // kept untouched, and re-enabling brings the card back (each number then needs a fresh QR scan).
  const qrCardVisible = Boolean(currentWorkspace?.qrPilotEnabled);
  const isInstagramConnected = Boolean(currentWorkspace?.instagramConnected);
  const isFacebookConnected = Boolean(currentWorkspace?.facebookConnected);
  const isShopifyConnected = Boolean(currentWorkspace?.shopifyConnected);
  const isChatbotConnected = Boolean(currentWorkspace?.websiteConnected);

  const [connectOpen, setConnectOpen] = useState(false);
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [qrDetailsOpen, setQrDetailsOpen] = useState(false);
  const [qrSettingsOpen, setQrSettingsOpen] = useState(false);
  const [instagramDetailsOpen, setInstagramDetailsOpen] = useState(false);
  const [shopifyDetailsOpen, setShopifyDetailsOpen] = useState(false);
  const [whatsappWebOpen, setWhatsappWebOpen] = useState(false);

  // shopifyConnected alone can't distinguish "never connected" from
  // "was connected, token got revoked/errored" — both show as false. Need the
  // integration's real status to tell those apart, so a broken-but-previously-
  // connected store shows "Reconnect" instead of a plain "Connect" (which
  // would misleadingly imply this is a first-time connection). A fetch
  // failure (e.g. 404 — no integration ever existed) is treated the same as
  // "never connected", not as an error state.
  const workspaceId = currentWorkspace?._id;
  const [shopifyIntegrationStatus, setShopifyIntegrationStatus] = useState(null);
  useEffect(() => {
    if (!workspaceId) return;
    let cancelled = false;
    (async () => {
      try {
        let token = getAccessToken();
        if (!token) token = await getAuthToken();
        if (!token) return;
        const data = await fetchShopifyStatus(workspaceId, token);
        if (!cancelled) setShopifyIntegrationStatus(data?.status || null);
      } catch (err) {
        if (!cancelled) setShopifyIntegrationStatus(null);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [workspaceId]);
  // The WhatsApp Web card reads its own On/Off from the settings endpoint (the switch lives in WhatsAppWebDialog, which reports
  // changes back through onChanged). Only asked while Meta is connected: without it the feature cannot be on.
  const [whatsappWebEnabled, setWhatsappWebEnabled] = useState(false);
  useEffect(() => {
    if (!workspaceId || !isWhatsAppConnected) {
      setWhatsappWebEnabled(false);
      return undefined;
    }
    let cancelled = false;
    (async () => {
      try {
        const token = (await getAuthToken()) || getAccessToken();
        const res = await axios.get(`${SERVER}/api/workspaces/${workspaceId}/whatsapp-web`, { headers: { Authorization: `Bearer ${token}` } });
        if (!cancelled) setWhatsappWebEnabled(res.data?.settings?.enabled === true);
      } catch (err) {
        if (!cancelled) setWhatsappWebEnabled(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [workspaceId, isWhatsAppConnected]);

  const shopifyNeedsReconnect =
    shopifyIntegrationStatus === "revoked" || shopifyIntegrationStatus === "error";

  // Same rationale as shopifyIntegrationStatus above: websiteConnected alone can't
  // distinguish "never connected" from "widget exists but paused/disabled" — both
  // show as false. The card-level Disconnect button also needs the widget's _id,
  // which isn't on the Redux workspace flag at all.
  const [chatbotWidget, setChatbotWidget] = useState(null);
  useEffect(() => {
    if (!workspaceId) return;
    let cancelled = false;
    (async () => {
      try {
        let token = getAccessToken();
        if (!token) token = await getAuthToken();
        if (!token) return;
        const widget = await fetchChatbotWidget(workspaceId, token);
        if (!cancelled) setChatbotWidget(widget);
      } catch (err) {
        if (!cancelled) setChatbotWidget(null);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [workspaceId]);
  const chatbotNeedsAttention = !!chatbotWidget && chatbotWidget.status !== "active";

  const handleChatbotChanged = () => {
    dispatch(fetchWorkspaces());
    if (workspaceId) {
      (async () => {
        try {
          let token = getAccessToken();
          if (!token) token = await getAuthToken();
          if (!token) return;
          setChatbotWidget(await fetchChatbotWidget(workspaceId, token));
        } catch (err) {
          setChatbotWidget(null);
        }
      })();
    } else {
      setChatbotWidget(null);
    }
  };

  // Disconnect hard-deletes the integration record (see disconnectShopify in
  // shopifyOAuthService.js) rather than marking it revoked — null here
  // matches what a fresh status fetch would return anyway
  // (INTEGRATION_NOT_FOUND), correctly falling back to a plain "Connect"
  // state rather than "Reconnect needed". isConnected reads
  // currentWorkspace.shopifyConnected from Redux, not this local status
  // state, so it needs its own refresh too — same fix ShopifyDetailsDialog's
  // own post-disconnect handler already applies.
  // Instagram / Facebook disconnect deletes the connection server-side; refresh the workspace so the
  // instagramConnected / facebookConnected flags (and the card state) update.
  const handleSocialDisconnected = () => {
    dispatch(fetchWorkspaces());
  };

  const handleShopifyDisconnected = () => {
    dispatch(fetchWorkspaces());
    setShopifyIntegrationStatus(null);
  };

  return (
    <Box
      sx={{
        // Cards sit directly on the page background now — no wrapper card and no
        // in-page "Integrations" title (PanelHeading in Settings.jsx already shows
        // it, and SettingsDetails' xs header does on mobile). 16px inset on the
        // sides/bottom — Settings.jsx zeroes its own padding for this tab so the
        // cards' hover shadow isn't clipped by the scroll container. Top gets extra
        // (24px) since the plain 16px still read as too close under the page
        // header/Popular pill (Rahim, 2026-09-23).
        pt: 3,
        px: 2,
        pb: 2,
        boxSizing: "border-box",
        color: "text.primary",
      }}
    >
      {/* Fixed column counts per breakpoint (was auto-fill/minmax(260px), 5 across on a
          1920 screen) — explicit repeat() so cards split the row's width evenly and
          read as wider rectangles instead of near-square tiles: max 4 across now,
          stepping down through 3/2/1 as the panel narrows, never more than 4. */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", md: "repeat(3, 1fr)", lg: "repeat(4, 1fr)" },
          gap: 3,
        }}
      >
        {CHANNELS.filter((c) => c.key !== "whatsapp-qr" || qrCardVisible).map((channel) => {
          const isConnected =
            (channel.key === "whatsapp" && isWhatsAppConnected) ||
            (channel.key === "whatsapp-qr" && (isQrConnected || hasConnectedQrNumber)) ||
            (channel.key === "whatsapp-web" && whatsappWebEnabled) ||
            (channel.key === "instagram" && isInstagramConnected) ||
            (channel.key === "messenger" && isFacebookConnected) ||
            (channel.key === "shopify" && isShopifyConnected) ||
            (channel.key === "chatbot" && isChatbotConnected);

          const canUseActions = channel.key === "whatsapp-web" ? canManageWhatsAppWeb : canManageIntegrations;

          // Footer actions — same conditions/handlers as before, only the layout moved.
          const actions = channel.real ? (
            channel.key === "instagram" ? (
              isConnected ? (
                <>
                  <Button variant="outlined" size="small" onClick={() => setInstagramDetailsOpen(true)} sx={CARD_BUTTON_SX}>
                    Details
                  </Button>
                  <DisconnectSocialButton channel="instagram" onDisconnected={handleSocialDisconnected} sx={CARD_BUTTON_SX} />
                </>
              ) : (
                <ConnectInstagramButton sx={CARD_BUTTON_SX} />
              )
            ) : channel.key === "messenger" ? (
              // No details dialog yet — reconnecting re-runs OAuth, which is also how the connected Page is switched.
              <>
                <ConnectFacebookButton label={isConnected ? "Reconnect" : "Connect"} sx={CARD_BUTTON_SX} />
                {isConnected && (
                  <DisconnectSocialButton channel="facebook" onDisconnected={handleSocialDisconnected} sx={CARD_BUTTON_SX} />
                )}
              </>
            ) : channel.key === "shopify" ? (
              <>
                {!isConnected && (
                  <ConnectShopifyButton label={shopifyNeedsReconnect ? "Reconnect" : "Connect"} sx={CARD_BUTTON_SX} />
                )}
                <Button variant="outlined" size="small" onClick={() => setShopifyDetailsOpen(true)} sx={CARD_BUTTON_SX}>
                  Details
                </Button>
                {(isConnected || shopifyNeedsReconnect) && (
                  <DisconnectShopifyButton onDisconnected={handleShopifyDisconnected} />
                )}
              </>
            ) : channel.key === "chatbot" ? (
              <>
                {!isConnected && !chatbotWidget && (
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => navigate(`/home/${accountid}/workspaces/${workspaceId}/chatbot-widget/connect`)}
                    sx={CARD_BUTTON_SX}
                  >
                    Connect
                  </Button>
                )}
                {chatbotWidget && (
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => navigate(`/home/${accountid}/workspaces/${workspaceId}/chatbot-widget/connect`)}
                    sx={CARD_BUTTON_SX}
                  >
                    Edit
                  </Button>
                )}
                {chatbotWidget && (
                  <DisconnectChatbotButton widgetId={chatbotWidget._id} onDisconnected={handleChatbotChanged} />
                )}
              </>
            ) : channel.key === "whatsapp-web" ? (
              <Button variant="outlined" size="small" onClick={() => setWhatsappWebOpen(true)} sx={CARD_BUTTON_SX}>
                {isConnected ? "Settings" : "Set up"}
              </Button>
            ) : channel.key === "whatsapp-qr" ? (
              // One place for every QR number: with none linked yet it is "Connect" (opens the add-number form),
              // otherwise "Manage numbers" plus "Number settings" (the two per-number send limits). Meta and QR
              // coexist in a workspace, so neither button is ever disabled because of the other. The QR
              // option only appears for accounts staff enabled; an account disabled later keeps this card
              // while it still has numbers, so existing numbers can always be viewed and disconnected.
              <>
                <Button variant="outlined" size="small" onClick={() => setQrDetailsOpen(true)} sx={CARD_BUTTON_SX}>
                  {hasQrConnectionRecord ? "Manage numbers" : "Connect"}
                </Button>
                {hasQrConnectionRecord && currentWorkspace?.qrPilotEnabled && (
                  <Button variant="outlined" size="small" onClick={() => setQrSettingsOpen(true)} sx={CARD_BUTTON_SX}>
                    Number settings
                  </Button>
                )}
              </>
            ) : isConnected ? (
              <Button variant="outlined" size="small" onClick={() => setDetailsOpen(true)} sx={CARD_BUTTON_SX}>
                Details
              </Button>
            ) : (
              <Button variant="outlined" size="small" onClick={() => setConnectOpen(true)} sx={CARD_BUTTON_SX}>
                Connect
              </Button>
            )
          ) : (
            <Tooltip title="Coming soon" placement="left">
              <span>
                <Button variant="outlined" size="small" disabled sx={CARD_BUTTON_SX}>
                  Connect
                </Button>
              </span>
            </Tooltip>
          );

          return (
            <Box key={channel.key} sx={{ minWidth: 0 }}>
              <Card
                variant="outlined"
                sx={{
                  position: "relative",
                  height: "100%",
                  minHeight: 240,
                  display: "flex",
                  flexDirection: "column",
                  // Card defaults to overflow:hidden, which would clip the Popular tab
                  // that sits half outside the top border. The tint below is a
                  // background, so it still follows the rounded corners.
                  overflow: "visible",
                  borderRadius: "12px",
                  backgroundColor: "transparent",
                  // Per-brand wash fading in from the top-right corner.
                  backgroundImage: (theme) =>
                    `linear-gradient(to bottom left, ${channel.tint}${theme.palette.mode === "dark" ? "2E" : "22"} 0%, transparent 55%)`,
                  transition: "box-shadow 0.2s",
                  "&:hover": { boxShadow: "0 4px 16px rgba(0,0,0,0.12)" },
                }}
              >
                {channel.badge && (
                  <Box sx={POPULAR_PILL_SX}>
                    <Box sx={{ width: 14, height: 14, display: "flex", flexShrink: 0 }}>
                      <Profile2User size="100%" color="currentColor" variant="Linear" />
                    </Box>
                    {channel.badge}
                  </Box>
                )}

                <CardContent
                  sx={{
                    p: 2.5,
                    pb: 0,
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    "&:last-child": { pb: 0 },
                  }}
                >
                  {/* Inbox type scale: title = Body Emphasis (0.9375rem/600), description =
                      Small/Label (0.8125rem). Set explicitly — variant="body2" renders at
                      10px in this theme. */}
                  <Stack direction="row" justifyContent="space-between" alignItems="flex-start" gap={2}>
                    <Typography
                      sx={{
                        // Extra breathing room above the title, mainly so it clears the
                        // Popular pill sitting half over the card's top border above it
                        // (Rahim, 2026-09-23).
                        mt: 0.75,
                        fontSize: "0.9375rem",
                        fontWeight: 600,
                        lineHeight: 1.3,
                        color: "text.primary",
                        minWidth: 0,
                      }}
                    >
                      {channel.name}
                    </Typography>

                    {/* Bare brand-colored glyph — no tile behind it. */}
                    <Box sx={{ width: 40, height: 40, flexShrink: 0, display: "flex", color: channel.color }}>
                      <channel.Logo />
                    </Box>
                  </Stack>

                  {/* mt:"auto" — CardContent is a flex column, this pins the description to
                      the bottom of that column so it sits right above the footer's own
                      border-top, instead of directly under the title (Rahim, 2026-09-23). */}
                  <Typography
                    title={channel.description}
                    sx={{
                      mt: "auto",
                      pt: 1.5,
                      fontSize: "0.8125rem",
                      color: "text.secondary",
                      lineHeight: 1.5,
                      display: "-webkit-box",
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                    }}
                  >
                    {channel.description}
                  </Typography>
                </CardContent>

                {/* Footer: status pill left, actions right, hairline above */}
                <Box
                  sx={{
                    mx: 2.5,
                    mt: 2,
                    mb: 2,
                    pt: 1.5,
                    borderTop: (theme) => `1px solid ${theme.palette.divider}`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 1,
                    flexWrap: "wrap",
                  }}
                >
                  <Stack direction="row" gap={0.75} alignItems="center">
                    {isConnected && (
                      <Typography sx={{ ...CARD_STATUS_TEXT_SX, color: "success.main" }}>
                        {channel.key === "whatsapp-web" ? "On" : "Connected"}
                      </Typography>
                    )}
                    {channel.key === "shopify" && !isConnected && shopifyNeedsReconnect && (
                      <Typography sx={{ ...CARD_STATUS_TEXT_SX, color: "warning.main" }}>Reconnect needed</Typography>
                    )}
                    {channel.key === "chatbot" && !isConnected && chatbotNeedsAttention && (
                      <Typography sx={{ ...CARD_STATUS_TEXT_SX, color: "warning.main" }}>
                        {chatbotWidget.status === "paused" ? "Paused" : "Disabled"}
                      </Typography>
                    )}
                  </Stack>
                  <Stack direction="row" gap={1} flexWrap="wrap" justifyContent="flex-end" sx={{ ml: "auto" }}>
                    {canUseActions ? actions : null}
                  </Stack>
                </Box>
              </Card>
            </Box>
          );
        })}
      </Box>

      <ConnectWhatsAppDialog
        open={connectOpen}
        onClose={() => setConnectOpen(false)}
      />
      <WhatsAppDetailsDialog
        open={detailsOpen}
        onClose={() => setDetailsOpen(false)}
        workspaceId={workspaceId}
      />
      <WhatsAppWebDialog
        open={whatsappWebOpen}
        onClose={() => setWhatsappWebOpen(false)}
        workspaceId={workspaceId}
        onChanged={(settings) => setWhatsappWebEnabled(settings.enabled === true)}
      />
      <WhatsAppQrNumbersDialog
        open={qrDetailsOpen}
        onClose={() => setQrDetailsOpen(false)}
        workspaceId={workspaceId}
      />
      <WhatsAppQrNumberSettingsDialog
        open={qrSettingsOpen}
        onClose={() => setQrSettingsOpen(false)}
        workspaceId={workspaceId}
      />
      <InstagramDetailsDialog
        open={instagramDetailsOpen}
        onClose={() => setInstagramDetailsOpen(false)}
      />
      <ShopifyDetailsDialog
        open={shopifyDetailsOpen}
        onClose={() => setShopifyDetailsOpen(false)}
        onDisconnected={handleShopifyDisconnected}
      />
    </Box>
  );
};

export default Integrations;
